var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 7.77778,
    fill: "#F5E75B",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 26.8327C19.3453 26.8327 21.1498 26.2853 22.6847 25.2597C24.2195 24.2342 25.4158 22.7765 26.1222 21.0711C26.8286 19.3656 27.0135 17.489 26.6533 15.6785C26.2932 13.868 25.4043 12.205 24.099 10.8997C22.7937 9.5944 21.1307 8.70549 19.3202 8.34536C17.5097 7.98523 15.6331 8.17006 13.9276 8.87648C12.2222 9.5829 10.7645 10.7792 9.73897 12.314C8.71341 13.8489 8.16602 15.6534 8.16602 17.4994C8.17316 19.9725 9.15878 22.3423 10.9076 24.0911C12.6564 25.8399 15.0262 26.8255 17.4993 26.8327Z",
    stroke: "#F5E75B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.499 13.7666V18.4333",
    stroke: "#F5E75B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4951 21.2324H17.504",
    stroke: "#F5E75B",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBg);
export default __webpack_public_path__ + "static/media/warning-bg.6bd8c7cbcf5420cfa1252143c6fbb617.svg";
export { ForwardRef as ReactComponent };